import { useContext, createContext } from "react"
import { useApartContext as useApart1 } from "./ApartContext_1"
import { useApartContext as useApart2 } from "./ApartContext_2"
import { useApartContext as useApart3 } from "./ApartContext_3"
import { useApartContext as useApart4 } from "./ApartContext_4"
import { useApartContext as useApart5 } from "./ApartContext_5"
import { useApartContext as useApart6 } from "./ApartContext_6"
import { useApartContext as useApart7 } from "./ApartContext_7"
import { useApartContext as useApart8 } from "./ApartContext_8"
import { useApartContext as useApart9 } from "./ApartContext_9"
import { useApartContext as useApart10 } from "./ApartContext_10"
import { useApartContext as useApart11 } from "./ApartContext_11"
import { useApartContext as useApart12 } from "./ApartContext_12"
import { useApartContext as useApart13 } from "./ApartContext_13"
import { useApartContext as useApart14 } from "./ApartContext_14"
import { useApartContext as useApart15 } from "./ApartContext_15"
import { useApartContext as useApart16 } from "./ApartContext_16"
import { useApartContext as useApart17 } from "./ApartContext_17"
import { useApartContext as useApart18 } from "./ApartContext_18"
import { useApartContext as useApart19 } from "./ApartContext_19"
import { useLanguage } from "../LanguageContext"

/**
 * Custom hook to access all apartment data with language support
 * Returns an array of all apartments with data in the current language
 */
export const useApartments = () => {
  const { apartmentData: apart1 } = useApart1()
  const { apartmentData: apart2 } = useApart2()
  const { apartmentData: apart3 } = useApart3()
  const { apartmentData: apart4 } = useApart4()
  const { apartmentData: apart5 } = useApart5()
  const { apartmentData: apart6 } = useApart6()
  const { apartmentData: apart7 } = useApart7()
  const { apartmentData: apart8 } = useApart8()
  const { apartmentData: apart9 } = useApart9()
  const { apartmentData: apart10 } = useApart10()
  const { apartmentData: apart11 } = useApart11()
  const { apartmentData: apart12 } = useApart12()
  const { apartmentData: apart13 } = useApart13()
  const { apartmentData: apart14 } = useApart14()
  const { apartmentData: apart15 } = useApart15()
  const { apartmentData: apart16 } = useApart16()
  const { apartmentData: apart17 } = useApart17()
  const { apartmentData: apart18 } = useApart18()
  const { apartmentData: apart19 } = useApart19()
  const { language } = useLanguage()

  // Combine all apartments into a single array
  const allApartments = [apart1, apart2, apart3, apart4, apart5, apart6, apart7, apart8, apart9, apart10, apart11, apart12, apart13, apart14, apart15, apart16, apart17, apart18, apart19]

  // Process apartments to use the correct language fields
  const processedApartments = allApartments.map(apt => {
    // Create a new object with the base properties
    const processedApt = { ...apt }

    // Replace title with language-specific version if available
    if (language === "he" && apt.titleHe) {
      processedApt.title = apt.titleHe
    } else if (language === "fr" && apt.titleFr) {
      processedApt.title = apt.titleFr
    } else if (language === "es" && apt.titleEs) {
      processedApt.title = apt.titleEs
    }

    // Replace description with language-specific version if available
    if (language === "he" && apt.descriptionHe) {
      processedApt.description = apt.descriptionHe
      processedApt.longDescription = apt.longDescriptionHe || apt.descriptionHe
    } else if (language === "fr" && apt.descriptionFr) {
      processedApt.description = apt.descriptionFr
      processedApt.longDescription = apt.longDescriptionFr || apt.descriptionFr
    } else if (language === "es" && apt.descriptionEs) {
      processedApt.description = apt.descriptionEs
      processedApt.longDescription = apt.longDescriptionEs || apt.descriptionEs
    }

    // Process amenities to use language-specific names
    if (apt.amenities && Array.isArray(apt.amenities)) {
      processedApt.amenities = apt.amenities.map(amenity => {
        if (typeof amenity === 'object') {
          if (language === "he" && amenity.nameHe) {
            return amenity.nameHe
          } else if (language === "fr" && amenity.nameFr) {
            return amenity.nameFr
          } else if (language === "es" && amenity.nameEs) {
            return amenity.nameEs
          } else {
            return amenity.name
          }
        }
        return amenity
      })
    }

    // Process location to use language-specific address
    if (apt.location && typeof apt.location === 'object') {
      const locationCopy = { ...apt.location }
      if (language === "he" && apt.location.addressHe) {
        locationCopy.address = apt.location.addressHe
      } else if (language === "fr" && apt.location.addressFr) {
        locationCopy.address = apt.location.addressFr
      } else if (language === "es" && apt.location.addressEs) {
        locationCopy.address = apt.location.addressEs
      }
      processedApt.location = locationCopy
    }

    // Process rules to use language-specific text
    if (apt.rules && Array.isArray(apt.rules)) {
      processedApt.rules = apt.rules.map(ruleItem => {
        if (typeof ruleItem === 'object') {
          if (language === "he" && ruleItem.ruleHe) {
            return ruleItem.ruleHe
          } else if (language === "fr" && ruleItem.ruleFr) {
            return ruleItem.ruleFr
          } else if (language === "es" && ruleItem.ruleEs) {
            return ruleItem.ruleEs
          } else {
            return ruleItem.rule
          }
        }
        return ruleItem
      })
    }

    return processedApt
  })

  return processedApartments
}

/**
 * Custom hook to get a specific apartment by ID
 * Returns the apartment data in the current language
 */
export const useApartmentById = (id) => {
  const apartments = useApartments()
  return apartments.find(apt => apt.id === parseInt(id)) || null
}

export default useApartments
